<div class="cb-footer">
  <div class="flex flex-row items-center justify-center">
    <img src="./assets/cb-mido-footer.png" alt="Colossus & MIDO">
  </div>
<!--  <div class="flex flex-row items-center justify-center mt-4">-->
<!--    <a class="underline" [routerLink]="['/', 'help', 'terms-of-play']">Patents</a>-->
<!--  </div>-->
</div>

